import { getBooleanFF } from '@atlaskit/platform-feature-flags';
import { supportedTranslationLanguagesEnglishAlphabeticalOrder, supportedTranslationLanguagesPopularOrder } from './types';
export const getSortedSupportedTranslationLanguages = () => {
  if (getBooleanFF('platform.editor.ai-multi-lang-translations-popular-sort-order')) {
    return supportedTranslationLanguagesPopularOrder;
  }
  return supportedTranslationLanguagesEnglishAlphabeticalOrder;
};
export const isTranslationPrompt = latestPrompt => {
  var _latestPrompt$presetT;
  return Boolean(latestPrompt === null || latestPrompt === void 0 ? void 0 : (_latestPrompt$presetT = latestPrompt.presetTitle) === null || _latestPrompt$presetT === void 0 ? void 0 : _latestPrompt$presetT.call(latestPrompt, {
    formatMessage: descriptor => {
      var _descriptor$defaultMe;
      return typeof descriptor.defaultMessage === 'string' && ((_descriptor$defaultMe = descriptor.defaultMessage) === null || _descriptor$defaultMe === void 0 ? void 0 : _descriptor$defaultMe.includes('Translate to {language}'));
    }
  }));
};